<template>
  <div>
    <div 
      @drop.prevent="addDropFile" 
      @dragover.prevent
    >
      <v-file-input
        class="validation-file-input"
        v-model="file"
        label="File input"
        prepend-icon="mdi-paperclip"
        outlined
        :loading="loading"
        :disabled="loading"
      >
      </v-file-input>
    </div>
    <v-btn
      :loading="loading"
      :disabled="loading"
      color="#2262c6"
      class="ma-2 white--text"
      @click="uploadFile"
    >
      Subir archivo
      
      <v-icon
        right
        dark
      >
        mdi-cloud-upload
      </v-icon>

      <template v-slot:loader>
        <span>Subiendo</span>
        <v-progress-circular
          indeterminate
          size="16"
          color="primary"
          class="ml-1"
        ></v-progress-circular>
      </template>
    </v-btn>
    <v-btn
      :loading="btnMydata.isLoading"
      :disabled="btnMydata.isDisabled"
      :depressed="btnMydata.isDisabled"
      color="white"
      class="ma-2"
      @click="showMydata"
    >
      Ver Datos
      
      <v-icon
        right
        dark
      >
        mdi-information
      </v-icon>

      <template v-slot:loader>
        <span>Cargando</span>
        <v-progress-circular
          indeterminate
          size="16"
          color="primary"
          class="ml-1"
        ></v-progress-circular>
      </template>
    </v-btn>
    <validation-dialog-confirmation
      v-if="showDialogConfirmation"
      :showDialog.sync="showDialogConfirmation"
      :dataFile="responseSuccess"
    ></validation-dialog-confirmation>
  </div>
</template>

<script>
import uris from '../../../utils/uris'
import axios from '../../../utils/axiosWrapperAutoservicio'
import eventBus from '../../../utils/eventBus'
import ValidationDialogConfirmation from './validation-dialog-confirmation.vue'

export default {
  name: 'validation-header',
  components: {
    ValidationDialogConfirmation
  },
  data () {
    return {
      btnMydata: {
        isLoading: false,
        isDisabled: true,
        asLogId: -1
      },
      loading: false,
      file: [],
      showDialogConfirmation: false,
      responseSuccess: {}
    }
  },
  created () {
    eventBus.$off('show-button-mydata')
    eventBus.$on('show-button-mydata', (option) => {
      this.btnMydata.isDisabled = option.isDisabled
      this.btnMydata.asLogId = option.asLogId !== 0 ? option.asLogId : -1
    })
  },
  props: {
    processID: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  methods: {
    addDropFile (e) {
      this.file = e.dataTransfer.files[0]
    },
    uploadFile () {
      this.loading = true
      let formData = new FormData()
      formData.append('processID', this.processID)
      formData.append('excel_file', this.file)

      axios.post(uris.URL_AUTOSERVICIO_VALIDATE_DATA,
        formData
      )
        .then((response) => {
          this.showDialogConfirmation = true
          this.responseSuccess = response.data
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.errors) {
            if (err.response.data.type === 'DQ') {
              eventBus.$emit('open-dialog-insert-data-error', {
                showDialog: true,
                errors: err.response.data
              })
            } else {
              eventBus.$emit('open-dialog-autoservicio-error', {
                showDialog: true,
                errors: err.response.data.errors,
                file: this.file
              })
            }
          }
          eventBus.$emit('open-custom-snack-bar', {message: err.response.data.error, itsOk: 'warning'})
          console.warn('No se ha podido subir el archivo', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    showMydata () {
      this.$router.push(`/autoservicios/data/${this.processID}/${this.btnMydata.asLogId}`)
    }
  }
}
</script>

<style>
.validation-file-input {
  width: 350px;
}
</style>


// WEBPACK FOOTER //
// src/components/autoservicios/validation/validation-upload-file.vue